/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apple_Support_Visit_LinkInputs */

const en_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit Apple Support to cancel`)
};

const id_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungi Dukungan Apple untuk membatalkan`)
};

const ms_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lawati Apple Support untuk batalkan`)
};

const ca_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per cancel·lar, visita el centre d'ajuda d'Apple`)
};

const cs_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro zrušení navštivte podporu Apple`)
};

const da_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besøg Apple Support for at opsige`)
};

const de_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zu Apple Support, um zu kündigen`)
};

const et_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tühistamiseks külastage Apple'i tugiteenust`)
};

const es_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al soporte de Apple para cancelar`)
};

const fr_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultez le centre d’aide Apple pour annuler.`)
};

const hr_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posjetite Appleovu Support kako biste otkazali`)
};

const it_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita il Supporto Apple per cancellare`)
};

const lv_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apmeklējiet Apple atbalsta dienestu, lai atceltu`)
};

const lt_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norėdami atšaukti, apsilankykite „Apple“ palaikymo svetainėje`)
};

const hu_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Látogasson el az Apple Support oldalára a törléshez`)
};

const nl_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar Apple Support om op te zeggen`)
};

const nb_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til Apple Support for å si opp`)
};

const pl_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwiedź Wsparcie Apple, aby anulować`)
};

const pt_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visite o Suporte da Apple para cancelar`)
};

const ro_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizitează Apple Support pentru a anula`)
};

const sk_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre zrušenie navštívte podporu Apple`)
};

const sl_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiščite Podporo podjetja Apple in prekličite`)
};

const fi_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käy Applen tuessa peruuttaaksesi`)
};

const sv_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besök Apple Support för att avbryta`)
};

const vi_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy cập Trung tâm trợ giúp của Apple để hủy`)
};

const tr_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal etmek için Apple Destek'i ziyaret edin`)
};

const el_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επισκεφθείτε την Υποστήριξη της Apple για ακύρωση`)
};

const bg_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посети Apple Support, за да отмениш`)
};

const ru_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для отмены обратитесь в службу поддержки Apple`)
};

const sr_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетите подршку за Apple да откажете`)
};

const uk_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зв'яжіться зі службою підтримки Apple, щоб скасувати підписку`)
};

const ka_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გაუქმებისთვის ეწვიეთ Apple-ის მხარდაჭერის სამსახურს`)
};

const hi_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करने के लिए एप्पल सपोर्ट से संपर्क करें`)
};

const th_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เยี่ยมชม Apple Support เพื่อยกเลิก`)
};

const ko_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple 지원팀 방문하여 취소`)
};

const zh_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问 Apple 支持以取消`)
};

const zh_tw_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請前往 Apple 支援取消`)
};

const ja_apple_support_visit_link = /** @type {(inputs: Apple_Support_Visit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセルするにはAppleサポートにアクセスしてください`)
};

/**
* | output |
* | --- |
* | "Visit Apple Support to cancel" |
*
* @param {Apple_Support_Visit_LinkInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const apple_support_visit_link = /** @type {((inputs?: Apple_Support_Visit_LinkInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apple_Support_Visit_LinkInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_apple_support_visit_link(inputs)
	if (locale === "ms") return ms_apple_support_visit_link(inputs)
	if (locale === "ca") return ca_apple_support_visit_link(inputs)
	if (locale === "cs") return cs_apple_support_visit_link(inputs)
	if (locale === "da") return da_apple_support_visit_link(inputs)
	if (locale === "de") return de_apple_support_visit_link(inputs)
	if (locale === "et") return et_apple_support_visit_link(inputs)
	if (locale === "es") return es_apple_support_visit_link(inputs)
	if (locale === "fr") return fr_apple_support_visit_link(inputs)
	if (locale === "hr") return hr_apple_support_visit_link(inputs)
	if (locale === "it") return it_apple_support_visit_link(inputs)
	if (locale === "lv") return lv_apple_support_visit_link(inputs)
	if (locale === "lt") return lt_apple_support_visit_link(inputs)
	if (locale === "hu") return hu_apple_support_visit_link(inputs)
	if (locale === "nl") return nl_apple_support_visit_link(inputs)
	if (locale === "nb") return nb_apple_support_visit_link(inputs)
	if (locale === "pl") return pl_apple_support_visit_link(inputs)
	if (locale === "pt") return pt_apple_support_visit_link(inputs)
	if (locale === "ro") return ro_apple_support_visit_link(inputs)
	if (locale === "sk") return sk_apple_support_visit_link(inputs)
	if (locale === "sl") return sl_apple_support_visit_link(inputs)
	if (locale === "fi") return fi_apple_support_visit_link(inputs)
	if (locale === "sv") return sv_apple_support_visit_link(inputs)
	if (locale === "vi") return vi_apple_support_visit_link(inputs)
	if (locale === "tr") return tr_apple_support_visit_link(inputs)
	if (locale === "el") return el_apple_support_visit_link(inputs)
	if (locale === "bg") return bg_apple_support_visit_link(inputs)
	if (locale === "ru") return ru_apple_support_visit_link(inputs)
	if (locale === "sr") return sr_apple_support_visit_link(inputs)
	if (locale === "uk") return uk_apple_support_visit_link(inputs)
	if (locale === "ka") return ka_apple_support_visit_link(inputs)
	if (locale === "hi") return hi_apple_support_visit_link(inputs)
	if (locale === "th") return th_apple_support_visit_link(inputs)
	if (locale === "ko") return ko_apple_support_visit_link(inputs)
	if (locale === "zh") return zh_apple_support_visit_link(inputs)
	if (locale === "zh-tw") return zh_tw_apple_support_visit_link(inputs)
	if (locale === "ja") return ja_apple_support_visit_link(inputs)
	return en_apple_support_visit_link(inputs)
});